import { useCallback, useEffect, useState } from 'react'
import { useWeb3React } from '@pancakeswap/wagmi'
import { BCC_API } from 'config/constants/endpoints'

// Retrieve promo code
const usePromoCode = () => {
  const { account } = useWeb3React()

  const handleFetchPromoCode = useCallback(async (seed, sig) => {
    if (!account) return ""
    const res = await fetch(`${BCC_API}/promocode?account=${account}&seed=${seed}&sig=${sig}`)
    if (res.ok) {
      const json = await res.json()
      if (json.status === 'success') {
        return json.data.code
      }
      throw json.data?.error
    }
    return ""
  }, [account])

  return { handleFetchPromoCode }
}

export default usePromoCode
